import type { MaskedInputProps } from '../types'
import type { InputRef, InputProps } from 'antd'
import type { LegacyRef } from 'react'

import { Input } from 'antd'
import { forwardRef } from 'react'
import InputMask from 'react-input-mask'

export const MaskedInput = forwardRef<unknown, MaskedInputProps>(function MaskedInput(props, ref) {
  const { size, mask, value, disabled } = props
  const maskedProps = {
    mask,
    value: value?.toString() ?? '',
    disabled
  }
  return (
    <InputMask {...maskedProps}>
      {(inputProps: InputProps) => (
        <Input
          {...inputProps}
          size={size}
          ref={ref as unknown as LegacyRef<InputRef>}
          disabled={Boolean(props.disabled)}
        />
      )}
    </InputMask>
  )
})
